(function(){"use strict";}());

angular.module("app")
    .directive("graphicPanelView", ["AppService","$timeout","$rootScope", function(AppService,$timeout,$rootScope){

        return {
            restrict: "A",
            replace: false,
            scope:{action:"&",pageval:"&",location:"=",resetgame:"&"},
            templateUrl: "views/graphic-panel.html",
            link: function($scope, element, attributes){
            	var trace = angular.trace;

            	$scope.slideIndex = 0;
            	$scope.count = 0;

            	//$timeout(initialize,100);
                $rootScope.$on("ready",initialize);

                  //$scope.$watch("ready",initialize);
                  $scope.$on("locationChange",onLocationChange);

            	$scope.advancePanel = function(){
                    if($scope.complete) return $scope.advancePage();
            		if($scope.slideIndex < $scope.count - 1) $scope.slideIndex++;
            		if($scope.slideIndex === $scope.count - 1) $scope.complete = true;
            	};

            	$scope.rewindPanel = function(){
            		if($scope.slideIndex > 0) $scope.slideIndex --;
            	};

            	$scope.getSlidePosition = function(index){
            		if(index < $scope.slideIndex) return "left";
            		if(index > $scope.slideIndex) return "right";
            		return "center";
            	};

            	$scope.advancePage = function(){
            		var page = $scope.pageval({value:$scope.panel.advanceToScreen});
                    if(attributes.final === "true") return $scope.resetgame();
            		$scope.action({page:page});
            	};

            	$scope.checkPageStatus = function(end){
            		if(end === true && $scope.slideIndex === $scope.count - 1) return true;
            		if(end === false && $scope.slideIndex === 0) return true;
            		return false;
            	};

            	function initialize(){
                    if(!attributes || !attributes.graphicPanelView) return;
            		$scope.panel = AppService.panels[attributes.graphicPanelView];
            		if(!$scope.panel) return;
            		$scope.count = $scope.panel.panels.length;
                    $scope.complete = false;
                    if($scope.count === 1) $scope.complete = true;
                    $scope.slideIndex = 0;
            	}
                  function onLocationChange(type,value){

                        if(!value || !attributes.location) return;
                        var panel = value.correct ? value.panel : value.feedback;
                        $scope.panel = AppService.panels[panel];

                        if(!$scope.panel) return;

                        if(panel == "nowhere"){
                            var evt = {
                                eventCategory: "GRTT: Map City Selection",
                                eventLabel: "GRTT: Incorrect Location"
                            };
                            gtag("event", "GRTT: navigate", evt);
                        }
                        $scope.complete = false;
                        $scope.count = $scope.panel.panels.length;
                        if($scope.count === 1) $scope.complete = true;
                        $scope.slideIndex = 0;
                  }
            }
        };

    }]);
